export const resetStateByPathName = (pathName) => {
    switch (pathName) {
        case '/admin/users':
            //store.dispatch(resetUsers());
            break;
        default:
            break;
    }
};
